var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-relative h-100 w-100"},[_c('div',{staticClass:"modal-pagetitle text-center text-white text-uppercase"},[_vm._v(" Das hat geklappt! ")]),_c('div',{staticClass:"modal-prompt w-50 h-50 text-center text-xl dead-center bold text-white"},[_c('p',[_vm._v("Schön, dass du bei uns bleibst!")])])])
}]

export { render, staticRenderFns }